import { JSX, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadingPage } from '@/pages/Loading/Loading';
import { useZeroDashSdk } from '@/contexts/ZeroDashSdkContext';

// Old routes: /:patientId/:analysisSetId/curation and /:patientId/:analysisSetId/curation/:tab
// New route:  /:publicSubjectId/:patientId/:analysisSetId/curation(/:tab)
// Registered at both "curation" and "curation/:tab", so `tab` is only present for the latter.
export default function LegacyCurationRouteRedirect(): JSX.Element {
  const navigate = useNavigate();
  const { analysisSetId, tab } = useParams();
  const zeroDashSdk = useZeroDashSdk();

  useEffect(() => {
    async function redirect(): Promise<void> {
      if (!analysisSetId) return;
      const aSet = await zeroDashSdk.curation.analysisSets.getAnalysisSetById(analysisSetId);
      if (aSet) {
        const suffix = tab ? `/${tab}` : '';
        navigate(`/${aSet.publicSubjectId}/${aSet.patientId}/${analysisSetId}/curation${suffix}`, { replace: true });
      }
    }

    redirect();
  }, [analysisSetId, tab, navigate, zeroDashSdk.curation.analysisSets]);

  return <LoadingPage />;
}
